module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "option-group"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.label) + "\n\t")]), _vm._v(" "), (_vm.tooltip && _vm.tooltip.text) ? _c('erco-tooltip', {
    attrs: {
      "variant": _vm.tooltip.variant,
      "title": _vm.tooltip.title,
      "text": _vm.tooltip.text
    }
  }) : _vm._e(), _vm._v(" "), (_vm.chained) ? _c('div', {
    staticClass: "wrap"
  }, [_c('b-form-radio', {
    attrs: {
      "options": _vm.options,
      "stacked": ""
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.valueChained),
      callback: function($$v) {
        _vm.valueChained = $$v
      },
      expression: "valueChained"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.chained) ? _c('div', {
    staticClass: "wrap",
    on: {
      "!click": function($event) {
        _vm.handleWrapClick($event)
      }
    }
  }, _vm._l((_vm.options), function(option, index) {
    return _c('b-form-radio', {
      key: option.value,
      attrs: {
        "options": [option],
        "stacked": ""
      },
      on: {
        "change": _vm.handleChange
      },
      model: {
        value: (_vm.value[index]),
        callback: function($$v) {
          var $$exp = _vm.value,
            $$idx = index;
          if (!Array.isArray($$exp)) {
            _vm.value[index] = $$v
          } else {
            $$exp.splice($$idx, 1, $$v)
          }
        },
        expression: "value[index]"
      }
    })
  })) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-606ba382"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErcoRadioGroup.vue
// module id = 624
// module chunks = 0